import D2AAcceleratedLearningTable from './D2AAcceleratedLearningTable.container';
export default D2AAcceleratedLearningTable;
